<template>
  <CContainer fluid class="p-0" v-show="!storePageLoading">
        <CRow>
            <CCol xl="12" md="12">
                <div class="position-relative">
                    <CEmbed
                        tag="div"
                        :src="this.src"
                        frameborder="0"
                    />

                    <CButton
                        color="secondary"
                        :class="['button','button--preview','shadow']"
                        @click="$router.push({ name: 'creativity' })"
                    >
                        <span class="button__icon text-white-50">
                            <CIcon :content="$options.icons.cilArrowThickFromRight"/>
                        </span>
                        <span class="button__text">
                            {{ $t("back") }}
                        </span>
                    </CButton>
                    <transition name="fade">
                        <CElementCover 
                            :boundaries="[{ sides: ['top', 'left'], query: 'iframe' }]"
                            :opacity="0.8"
                            v-if="loading"
                        >
                            <!-- <h1 class="d-inline">Loading... </h1> -->
                            <CSpinner size="5xl" color="dark"/>
                        </CElementCover>
                    </transition>
                    
                </div>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import axios from 'axios';
import { cilArrowThickFromRight } from '@coreui/icons';
import pageMixin from '~/mixins/page.js';
export default {
    name:"TemplatePreviewPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin ],
    layout: "preview",
    icons:{
        cilArrowThickFromRight
    },
    data(){
        return {
            landing_page:"",
            url:"",
            html:null,
            loading:true,
            src:null
        }
    },
    computed:{
        template_id:function(){
            return this.$route.params.uuid;
        }
    },  
    methods:{
        base64Decode( str ) {
            return decodeURIComponent(escape(window.atob( str )));
        },
        async buildFormPreview(form_uuid){
            try {
                const { data } = await axios.get('/template.api/'+ form_uuid + "/deploy" );
                this.url = this.base64Decode(data.landing_page);
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async getFormPreview(){
            try {
                let axios_config = {
                    baseURL:this.url,
                    method:'GET'
                };
                /* axios_config.baseURL = this.url; */
                const { data } = await axios(axios_config);
                this.html = data;
            } catch (error) {
                this.showMessageError(error); 
            }
        },
        getBlobURL(code, type){
            const blob = new Blob([code], { type });
            return URL.createObjectURL(blob);
        }

            
    },
    async mounted(){
        try {
            if(this.template_id){
            
                await this.buildFormPreview(this.template_id);
                await this.getFormPreview();
                if(!this.html){
                    throw { code: 424, message: this.$t("html_does_not_load") };
                }
                
                this.src = this.getBlobURL(this.html,'text/html');
                this.loading = false;
                this.$store.dispatch('page/updateLoading', {
                    loading: false,
                });
            }
        } catch (error) {
            this.showMessageError(error);
        }
        
        
    }
}
</script>

<style scoped>
    #iframe-preview{
        width: 100%;
        height: 100vh;
    }
</style>